module.exports = __webpack_public_path__ + "static/media/radianceDNAEssence.9277eb59.png";